import React from 'react';
const Icon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path d="M32 58.6667C46.7276 58.6667 58.6667 46.7276 58.6667 32C58.6667 17.2724 46.7276 5.33334 32 5.33334C17.2724 5.33334 5.33334 17.2724 5.33334 32C5.33334 46.7276 17.2724 58.6667 32 58.6667Z"
            stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M24.24 24C24.8669 22.2178 26.1044 20.715 27.7332 19.7577C29.362 18.8004 31.277 18.4505 33.1391 18.7699C35.0012 19.0893 36.6902 20.0574 37.9069 21.5027C39.1236 22.9481 39.7895 24.7774 39.7867 26.6667C39.7867 32 31.7867 34.6667 31.7867 34.6667"
            stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M32 45.3333H32.0267" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export default Icon;